const API_BASE_URL = '/custom-includes/php/api/blog_api.php';

class BlogApiService {
  async makeRequest(endpoint, params = {}) {
    try {
      const url = new URL(API_BASE_URL, window.location.origin);
      url.searchParams.append('endpoint', endpoint);
      
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });

      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async getAllPosts(limit = null, offset = 0) {
    return this.makeRequest('posts', { limit, offset });
  }

  async getPostById(id) {
    return this.makeRequest('post', { id });
  }

  async getPostBySlug(slug) {
    return this.makeRequest('post', { slug });
  }

  async getRecentPosts(limit = 5) {
    return this.makeRequest('recent', { limit });
  }

  async getPopularTags(limit = 6) {
    return this.makeRequest('tags', { limit });
  }

  async getPopularCategories(limit = 6, searchQuery = '') {
    const params = { limit };
    if (searchQuery && searchQuery.trim() !== '') {
      params.search_query = searchQuery.trim();
    }
    return this.makeRequest('categories', params);
  }

  async getPostsByTag(tagId, limit = null, offset = 0) {
    return this.makeRequest('posts-by-tag', { tag_id: tagId, limit, offset });
  }

  async getPostsByCategory(categoryId, limit = null, offset = 0) {
    return this.makeRequest('posts-by-category', { category_id: categoryId, limit, offset });
  }

  async searchPosts(query, categoryId = null, limit = null, offset = 0) {
    const params = { q: query, limit, offset };
    if (categoryId) {
      params.category_id = categoryId;
    }
    return this.makeRequest('search', params);
  }

  async getRelatedPosts(postId, limit = 3) {
    return this.makeRequest('related-posts', { post_id: postId, limit });
  }
}

const blogApi = new BlogApiService();
export default blogApi;